import type { ReactNode } from 'react';
import { ArrowLeft } from '@phosphor-icons/react';

type PageHeaderProps = {
  eyebrow: string;
  title: string;
  subtitle: string;
  back?: () => void;
  children: ReactNode;
  action?: ReactNode;
  className?: string;
};

export default function PageHeader({
  eyebrow,
  title,
  subtitle,
  back,
  children,
  action,
  className = '',
}: PageHeaderProps) {
  return (
    <main className={`page ${back ? 'settings-subpage' : ''} ${className}`}>
      <header className="page-header">
        {back && (
          <button className="icon-btn" onClick={back}>
            <ArrowLeft />
          </button>
        )}
        <div>
          <span className="eyebrow coral">{eyebrow}</span>
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
        {action}
      </header>
      {children}
    </main>
  );
}
